export const DONUT_CHART_HINTS = {
  VALUE: '* en cantidades unitarias y porcentuales',
}

export const TIPO_ACCIDENTE_CHART = {
  title: 'Tipo de accidente*',
  leftHint: 'No incluye los siniestros rechazados',
  rightHint: DONUT_CHART_HINTS.VALUE,
  ariaLabel: 'Gráfico de dona de tipo de accidente',
  segments: [
    { name: 'Lugar de trabajo', color: '#1A49E0' },
    { name: 'In itínere', color: '#123A93' },
    { name: 'Enfermedad profesional', color: '#2D98A8' },
    { name: 'COVID', color: '#3FCAD1' },
  ],
}

export const GRAVEDAD_CHART = {
  title: 'Tipo de gravedad*',
  leftHint: 'No incluye los siniestros rechazados ni COVID',
  rightHint: DONUT_CHART_HINTS.VALUE,
  ariaLabel: 'Gráfico de dona de tipo de gravedad',
  segments: [
    { name: 'Leve', color: '#123A93' },
    { name: 'Moderado', color: '#1A49E0' },
    { name: 'Grave', color: '#2D98A8' },
    { name: 'Mortales', color: '#3FCAD1' },
    { name: 'Otros', color: '#0065FF' },
  ],
}

export const EVOLUCION_DENUNCIAS_CHART = {
  title: 'Evolución mensual de las denuncias',
  ariaLabel: 'Gráfico de barras de evolución mensual de las denuncias',
  series: [
    { key: 'lugarTrabajo', name: 'Lugar de trabajo', color: '#002F87' },
    { key: 'inItinere', name: 'In itínere', color: '#25B4BD' },
    { key: 'enfermedadProfesional', name: 'Enfermedad profesional', color: '#0091FF' },
  ],
}
